import { connect, mapProps } from '@formily/react';
import { mapSize, mapStatus } from "../__builtins__";
import { CnStep as UiCnStep, CnStepItem as UiCnStepItem, } from "../../components/cn-step";
export var CnStep = connect(UiCnStep, mapProps({
    value: 'current',
}, mapSize, mapStatus));
CnStep.displayName = 'CnStep';
export var CnStepItem = connect(UiCnStepItem, mapProps(mapSize, mapStatus));
CnStepItem.displayName = 'CnStepItem';
